<template>
    <div class="wrapper">
        <div class="title">404</div>
        <div class="engtext">Page Not Found.</div>
        <div class="chitext">找不到網頁</div>
        <div class="push_to_home">
            <v-btn
                @click="goBackHome"
                class="btn-primary white--text"
                
            >
                回首頁
            </v-btn>
        </div>
    </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
    name: "NotFound",
    components: {

    },
    data() {
        return {

        }
    },
    methods: {
        goBackHome() {
            // this.$router.push('/:container_id/home')
            console.log(this.$route);
            this.$router.push(`/${this.selectedOrg.org_id}/${this.selectedContainer.id}/home`)
        }
    },
    computed: {
      ...mapGetters(["selectedOrg","selectedContainer"]),
    }
}
</script>

<style scoped>
    .wrapper{
        min-height: 100%;
        height: auto !important;
        margin: 0 auto -235px;
        text-align: center;
        padding: 0px 30px;
        font-family: "Source Sans Pro","Open Sans","Helvetica Neue", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
    }
    .title{
        font-size: 700% !important;;
        font-weight: 900;
        color: rgba(0,0,0,0.3);
        line-height: 100px;
        margin-bottom: 15px;
        padding-top: 80px;
        letter-spacing: -1px;
    }
    .engtext{
        font-size: 140%;
        font-weight: 800;
        color: rgba(0,0,0,0.7);
        line-height: 50px;
    }
    .chitext{
        font-size: 140%;
        font-weight: 800;
        color: rgba(0,0,0,0.7);
        line-height: 30px;
        margin-bottom: 30px;
    }
</style>